import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Global from '../../../../store/global-selectors';
import { emptyArray, emptyObject } from 'ui-components/default-props/empty';

export const NO_OFFLINE_PRINTERS_RESPONSE = { hasOfflinePrinter: false };

const isPrintSettingAConnectPrinterCheck = (printSetting) => !!printSetting?.workstationId;

const getAreAllPrintersOnline = ({ printSettingsThatUseConnectPrinters, connectPrinters }) =>
  printSettingsThatUseConnectPrinters.every((printSetting) => {
    return connectPrinters.some((printer) => printer.id === printSetting.id);
  });

export const getAllOfflinePrinters = ({ printSettings = {}, connectPrinters = [] }) => {
  const printSettingsThatUseConnectPrinters = Object.values(printSettings).filter(isPrintSettingAConnectPrinterCheck);

  if (printSettingsThatUseConnectPrinters.length === 0) {
    return NO_OFFLINE_PRINTERS_RESPONSE;
  }

  const areAllPrintersOnline = getAreAllPrintersOnline({
    printSettingsThatUseConnectPrinters,
    connectPrinters,
  });
  if (areAllPrintersOnline) {
    return NO_OFFLINE_PRINTERS_RESPONSE;
  }

  const offlinePrinterNames = [
    ...new Set(printSettingsThatUseConnectPrinters.filter((printSetting) => !connectPrinters.includes(printSetting.id)).map((p) => p.name)),
  ];

  return { hasOfflinePrinter: true, offlinePrinterNames };
};

export const useCheckPrinterStatuses = () => {
  const printSettings = useSelector(Global.selectPrintSettingsPrintSettings) ?? emptyObject;
  const connectPrinters = useSelector(Global.selectConnectFlattenedPrinters) ?? emptyArray;

  return useMemo(() => {
    return getAllOfflinePrinters({ printSettings, connectPrinters });
  }, [connectPrinters, printSettings]);
};
